import api from '@/lib/api';

export interface Watcher {
  id: string; // user id
  email: string;
  first_name: string | null;
  last_name: string | null;
  created_at: string;
}

export const watchersService = {
  async list(ticketId: string): Promise<Watcher[]> {
    const res = await api.get(`/tickets/${ticketId}/watchers`);
    return res.data?.data || [];
  },

  async add(ticketId: string, userId: string): Promise<Watcher> {
    const res = await api.post(`/tickets/${ticketId}/watchers`, { userId });
    return res.data?.data;
  },

  async remove(ticketId: string, userId: string): Promise<void> {
    await api.delete(`/tickets/${ticketId}/watchers/${userId}`);
  },
};

export const watcherName = (w: Watcher): string => {
  const full = [w.first_name, w.last_name].filter(Boolean).join(' ').trim();
  return full || w.email?.split('@')[0] || 'Benutzer';
};
